<jjames-card>
    <div class="p-6">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <h2 class="text-2xl font-semibold text-gray-800 mb-6">Basic Information</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <mat-form-field appearance="fill" class="md:col-span-2">
                    <mat-label>Parking Space Name</mat-label>
                    <input matInput formControlName="name" required>
                    @if (form.get('name')?.hasError('required')) {
                    <mat-error>Name is required</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="fill" class="md:col-span-2">
                    <mat-label>Description</mat-label>
                    <textarea matInput formControlName="description"></textarea>
                </mat-form-field>

                <div class="md:col-span-2">
                    <h3 class="text-lg font-medium text-gray-900 mb-4">Address</h3>
                    <app-address-item formControlName="address"></app-address-item>
                </div>

                <mat-form-field appearance="fill">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="type" required>
                        @for (type of parkingSpaceTypes; track type) {
                        <mat-option [value]="type">
                            {{ type }}
                        </mat-option>
                        }
                    </mat-select>
                    @if (form.get('type')?.hasError('required')) {
                    <mat-error>Type is required</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Access Mode</mat-label>
                    <mat-select formControlName="accessMode" required>
                        @for (mode of parkingAccessModes; track mode) {
                        <mat-option [value]="mode">
                            {{ mode }}
                        </mat-option>
                        }
                    </mat-select>
                    @if (form.get('accessMode')?.hasError('required')) {
                    <mat-error>Access Mode is required</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Entry Type</mat-label>
                    <mat-select formControlName="entryType" required>
                        @for (type of parkingEntryTypes; track type) {
                        <mat-option [value]="type">
                            {{ type }}
                        </mat-option>
                        }
                    </mat-select>
                    @if (form.get('entryType')?.hasError('required')) {
                    <mat-error>Entry Type is required</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Old Parking Site ID (optional)</mat-label>
                    <input matInput formControlName="oldParkingSiteId" type="number" placeholder="Legacy site ID">
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>EFSTA location (TL, optional)</mat-label>
                    <input matInput formControlName="fiscalTransactionLocation">
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>EFSTA terminal (TT, optional)</mat-label>
                    <input matInput formControlName="fiscalTransactionTerminal">
                    @if (form.hasError('fiscalRegisterPair')) {
                    <mat-hint class="text-red-600">Set both or neither.</mat-hint>
                    }
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Governing organisation (optional)</mat-label>
                    <mat-select formControlName="externalOrganizationId">
                        <mat-option [value]="null">None — operator-governed</mat-option>
                        @for (org of organizations(); track org.id) {
                        <mat-option [value]="org.id">{{ org.name }}</mat-option>
                        }
                    </mat-select>
                    <mat-hint>SSO logins at this space are enrolled as members of this organisation. Grants no
                        parking by itself — it is what lets you place them in one of its pools afterwards.</mat-hint>
                </mat-form-field>
            </div>

            <!-- Restricted-access (visitor) window — Closed spaces only -->
            @if (isClosedSpace) {
            <div class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-1">Visitor Access Window</h3>
                <p class="text-sm text-gray-500 mb-3">
                    This space is Closed (authorized vehicles only). Optionally open it to visitors during a daily
                    window — they pay short-term while it is open and are denied outside it.
                </p>
                <app-access-window-field [(value)]="restrictedWindow"
                    enabledLabel="Open this closed space to visitors during a daily window"
                    description="Visitors may only enter during these hours (camera-local). Registered, pool and exempt vehicles are unaffected."
                    defaultStart="17:00" defaultEnd="23:59" />
            </div>
            }

            <!-- Actions -->
            <div class="flex justify-end gap-4 mt-8">
                <button type="button" mat-stroked-button (click)="onCancel()">
                    Cancel
                </button>
                <button type="submit" mat-flat-button color="primary" [disabled]="isSaving()">
                    @if (!isSaving()) {
                    <span>Create and Continue</span>
                    }
                    @if (isSaving()) {
                    <span>Creating...</span>
                    }
                </button>
            </div>
        </form>
    </div>
</jjames-card>